import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class OrderDownloadResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/orders/download' as const;

  pk() {
    return 'download';
  }
}
